(function() {
    'use strict';

    angular.module("imApp").factory("orderpickStatusService", ['$ihttp', function ($ihttp) {
        var service = {
            init: function () {
                return $ihttp.post({
                    method: 2507,
                    parameters: {
                        state: 'init'
                    }
                });
            }
        }

        return service;
    }]);
})();
